import { render, staticRenderFns } from "./CurriculumListNECPure.vue?vue&type=template&id=fa524f0c&scoped=true&"
import script from "./CurriculumListNECPure.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListNECPure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa524f0c",
  null
  
)

export default component.exports